/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons/index.js";
import CommonAlertCard from "../../../../../components/_utils/CommonAlertCard/index.jsx";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../../components/_utils/PaginationComponent/index.jsx";
import InternalAccountDetailsPopup from "../../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import Loader from "../../../../../components/Loader/Index.jsx";
import InternalTransactionDetailsPopup from "../../../../../components/Transactions/InternalTransaction/InternalTransactionDetailsPopup/index.jsx";
import InternalTransactionMultiApprovalCard from "../../../../../components/Transactions/InternalTransaction/InternalTransactionMultiApprovalCard/index.jsx";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { internalTransactionsActionable } from "../../../../../redux/features/transactions/internalTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../../utils/bankingHours.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../../utils/configurationProvider.js";
import useMultiSelect from "../../../../../utils/useMultiSelect.js";
import "./index.css";

const InternalTransactionMultiSelect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleChange, handleSelectAll: handleMultiSelectAll } =
    useMultiSelect();
  const [filterOpen, setFilterOpen] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedPageValue, setSelectedPageValue] = useState(50);
  const [impureData, setImpureData] = useState({});
  const [, setselectAllCard] = useState(false);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [, setApprovedAccounts] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [txnId, setTxnId] = useState(null);
  const [showMultiTxnDetailPop, setShowMultiTxnDetailPop] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [internalAccountid, SetInternalAccountid] = useState("");
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [labels, setLabels] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const filterRef = useRef(null);
  const filterRef1 = useRef(null);
  const [showSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchText] = useState("");
  const [searchUserTextDebounce, setsearchUserTextDebounce] = useState("");
  const [inputData, setInputData] = useState([]);
  const [active, setActive] = useState("");
  const [, setIsOpen] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const { internalTransactionsActionableData } = useSelector(
    (state) => state.internalTransactions,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    impureData &&
    impureData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const isTransactionPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) => transaction?.lifecycle_status === "pending",
    ) && isOutsideBankingHoursNow;

  const isAccountApprovalPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) =>
        transaction?.beneficiary_account_approval_status === "pending",
    ) && isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    isTransactionPendingOutsideBankingHours ||
    isAccountApprovalPendingOutsideBankingHours;

  const onMount = () => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(
      internalTransactionsActionable({
        page_no: page,
        page_size: pageSize,
        search: searchText || undefined,
        labels: LabelSearchText,
      }),
    )
      .then((response) => {
        setImpureData(response?.payload);
        const newData =
          response?.payload?.transactions?.map((account) => ({
            ...account,
            loading: false,
            error: "false",
            message: "",
          })) || [];

        setAllAccounts(newData);

        setAllBeneTxnAccountsLoading(false);

        const approved = newData.filter(
          (account) => account.internal_account_approval_status === "approved",
        );
        setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
      })
      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };
  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [page, pageSize, LabelSearchText, searchText, markerData]);

  const handlePageSelect = (value) => {
    setSelectedPageValue(value);
    setPageSize(value);
    handleChange(
      selectedSendTransactions,
      setSelectedSendTransactions,
      PaginationConfiguration.paginationSmall,
      selectedSendTransactions,
    );
    setPage(1);
  };

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        setFilterOpen(false);
      } else if (filterRef1.current && filterRef1.current.contains(e.target)) {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handlefilter);
  }, [filterOpen]);

  useEffect(() => {
    const selectedIds =
      selectedSendTransactions?.map((item) => item?.txn_id) || [];
    setSelectedTransactions(selectedIds);
    const total = selectedSendTransactions?.reduce(
      (sum, transaction) =>
        sum +
        Number(transaction?.amount || GlobalConfiguration.lengthCheckZero),
      GlobalConfiguration?.lengthCheckZero,
    );
    setTotalAmount(total);
  }, [selectedSendTransactions, setSelectedTransactions, setTotalAmount]);

  const approvedData = allAccounts
    .filter(
      (account) => account.internal_account_approval_status === "approved",
    )
    .map((account) => ({ ...account, id: account?.txn_id }));

  const handleSelectAll = () => {
    handleMultiSelectAll(
      selectedSendTransactions,
      setSelectedSendTransactions,
      PaginationConfiguration.paginationSmall,
      approvedData,
    );
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("internalTxnLabels");
    const parsedLabels = JSON.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;

      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedLabels, filterOpen]);

  const handleFilterCategory = () => {
    setLabelSearchText(selectedLabels);
    setPage(1);
    setFilterOpen(false);
  };

  const openMultiTxnDetailModal = () => {
    setShowMultiTxnDetailPop(true);
  };

  const closeInternalTxnDetailModal = () => {
    setShowMultiTxnDetailPop(false);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailOpen(false);
  };

  return (
    <>
      {showMultiTxnDetailPop ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalTransactionDetailsPopup
            closeInternalTxnDetailModal={closeInternalTxnDetailModal}
            internal_txn_id={txnId}
            type={"internal_txn_detail_modal"}
            setShowInternalTxnDetailPop={setShowMultiTxnDetailPop}
            error_msg={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      ) : null}

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}

      {internalAccDetailOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccountid}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}
      <div className="bg-primary-bg flex flex-col h-screen overflow-hidden relative pb-pagination-height">
        <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>

        <TopNavComponent
          handleBack={() => navigate(-1)}
          topNavHeader={totalAmount}
          ispagination={shouldShowPagination}
          isFormattingNotRequired={false}
          prevBalance={0}
          ownerAccBalanceLoading={false}
          BalanceStateRequired={true}
          AllPageRefresh={false}
          topNavSubText="Total amount"
          isSelectionView={true}
          selectionText={`Transactions selected : ${selectedTransactions.length}`}
          selectionBtnProps={
            !shouldShowPagination
              ? undefined
              : {
                  btnText: `Select up to 50`,
                  enabledBgColor:
                    selectedTransactions?.length ===
                    PaginationConfiguration.paginationSmall
                      ? "var(--positive-bg)"
                      : "var(--primary-act)",
                  hoverOption:
                    selectedTransactions?.length ===
                    PaginationConfiguration.paginationSmall
                      ? "black"
                      : "white",
                  enabledTextColor: "var(--text-primary)",
                  icon:
                    selectedTransactions?.length ===
                    PaginationConfiguration.paginationSmall
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  handleFunction: () => {
                    handleSelectAll();
                  },
                }
          }
          topNavCtaBtn2Props={{
            inActiveVariantNeeded: true,
            btnText: "Next",
            btnType: "button",
            enabledBgColor: "var(--text-primary)",
            enabledTextColor: "var(--primary-bg)",
            isDisabled: !selectedTransactions?.length,
            disabledBgColor: "var(--text-disabled)",
            disabledTextColor: "var(--text-primary)",
            handleFunction: () => {
              if (
                selectedTransactions?.length >=
                GlobalConfiguration?.lengthCheckOne
              ) {
                const selectedData = {
                  selectedSendTransactions,
                  selectedTransactions,
                  timestamp: Date.now(),
                };
                sessionStorage.setItem(
                  "selectedData",
                  JSON.stringify(selectedData),
                );

                navigate(
                  "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval",
                );
              }
            },
          }}
          isToggleNeeded={true}
          toggleProps={{
            state: false,
            title: "Single Approval",
            handleClick: () =>
              navigate(
                "/internal_transaction_dashboard/internal_transaction_single_approval",
              ),
          }}
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            showSearchBar: showSearchBar,
            isSearchDisabled: allBeneTxnAccountsLoading,
            onSearchInput: (val) => {
              setsearchUserTextDebounce(val);
            },
            searchText: searchUserTextDebounce,
            searchPlaceholder: "Search internal transaction",
            filterPlaceholder: "Search internal transaction",
            filterItems: [
              {
                name: "Labels",
                short_name: "Lab",
                isMulti: true,
                value: LabelSearchText,
                setValue: (val) => {
                  setPage(1);
                  setLabelSearchText(val);
                },
                isDropdown: true,
              },
            ],
            isSearchClearAllDisabled: !LabelSearchText?.length,

            inputData: inputData,
            active: active,
            setActive: setActive,
            loading: loadingData,
            setLoading: setLoadingData,
            isShowFilter: false,
            isShowSortBy: false,
          }}
        />
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center relative Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div
            ref={filterRef}
            className="w-width-full overflow-y-auto"
            style={{
              overflow: filterOpen || showInnerSearchBar ? "hidden" : "auto",
              scrollPadding: "var(--padding-md)",
            }}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex h-height-full">
                <Loader />
              </div>
            ) : internalTransactionsActionableData === undefined ||
              !allAccounts?.length ? (
              <div className={`int-txn-mutli-no-account-found`}>
                <div className="flex justify-center items-center">
                  <img
                    src={
                      LabelSearchText?.length && !allAccounts?.length
                        ? ICONS?.NO_DATA_FOUND
                        : ICONS?.NO_PENDING_TRANSACTION
                    }
                    // className="px-padding-sm w-graphic-width-md h-graphic-square-height-md int_txn_img"
                    alt="No data found"
                  />
                </div>
                <div className="int-txn-mutli-left-text-content-no-account">
                  <>
                    {LabelSearchText?.length &&
                    (!allAccounts?.length ||
                      allAccounts?.length === undefined) ? (
                      <>
                        <p className="text-font-md text-text-primary text-center">
                          No data found.
                        </p>
                        <div className="mt-margin-sm">
                          <PrimaryButton
                            btnText="Clear parameters"
                            handleFunction={() => {
                              setLabelSearchText("");
                              setSelectedLabels([]);
                            }}
                            enabledBgColor="var(--primary-act)"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="text-font-md text-text-primary text-center">
                          There are no more transactions that require <br />
                          your approval.
                        </p>
                        <div className="mt-margin-sm">
                          <PrimaryButton
                            btnText="Internal transaction dashboard"
                            handleFunction={() => {
                              navigate("/internal_transaction_dashboard");
                            }}
                            enabledBgColor="var(--primary-act)"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                          />
                        </div>
                      </>
                    )}
                  </>
                </div>
              </div>
            ) : (
              <>
                {allAccounts?.length ? (
                  <div
                    className={`flex flex-col flex-1 items-center justify-center mx-auto ${
                      showInnerSearchBar ? "pointer-events-none" : ""
                    }`}
                    style={{
                      scrollPaddingTop: "var(--padding-md)",
                      scrollPaddingBottom: "var(--padding-md)",
                    }}
                  >
                    {shouldShowBankingHoursAlert && (
                      <div className="max-w-tab-width-normal w-full Qlg:mx-auto pt-padding-md px-padding-md Qlg:px-padding-base">
                        <CommonAlertCard
                          title="Functioning outside banking hours"
                          texts="Transactions will be processed automatically during the next bank working day. Learn more"
                          highlightedText={["Learn more"]}
                          onHighlightedTextClick={(event, index) => {
                            if (index === 0) {
                              setShowBankingHoursPopup(true);
                            }
                          }}
                        />
                      </div>
                    )}
                    <InternalTransactionMultiApprovalCard
                      filterRef={filterRef}
                      filterOpen={filterOpen}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedPageValue={selectedPageValue}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      txnId={txnId}
                      setTxnId={setTxnId}
                      openMultiTxnDetailModal={openMultiTxnDetailModal}
                      SetInternalAccountid={SetInternalAccountid}
                      internalAccDetailOpen={internalAccDetailOpen}
                      setInternalAccDetailOpen={setInternalAccDetailOpen}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
        {shouldShowPagination && (
          <div className="w-full z-z-index-fixed-ui relative">
            {showInnerSearchBar && (
              <div className="absolute inset-top-base bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header pointer-events-none"></div>
            )}
            <PaginationComponent
              data={impureData}
              currentPage={page}
              dropdownOptions={[50, 100]}
              pageSize={pageSize}
              selectedValue={selectedPageValue}
              handleSelect={handlePageSelect}
              handlePagination={setPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default InternalTransactionMultiSelect;
